import { FC } from 'react';
import { LanguagePairLearnable } from 'src/types/domain';
import * as S from './styles';
import { DictionaryListElement, SearchData } from './DictionaryListElement';

interface Props {
  isLoading: boolean;
  list: LanguagePairLearnable[];
  currentPage: number;
  searchData: SearchData;
}

export const DictionaryList: FC<Props> = ({ isLoading, list, currentPage, searchData }) => {
  return (
    <S.List data-testid="dictionary-list">
      {list?.map(learnable => (
        <DictionaryListElement
          key={learnable.learnableId}
          learnable={learnable}
          isLoading={isLoading}
          currentPage={currentPage}
          searchData={searchData}
        />
      ))}
    </S.List>
  );
};
